import { create } from "zustand";
import {
  DEFAULT_CLOSET,
  type ClosetSpec,
  type ClosetSection,
} from "../domain/types";

interface State {
  spec: ClosetSpec;
  setSpec: (next: ClosetSpec) => void;
  patch: (patch: Partial<ClosetSpec>) => void;
  patchMaterial: (patch: Partial<ClosetSpec["material"]>) => void;
  patchCeiling: (patch: Partial<ClosetSpec["ceiling"]>) => void;
  updateSection: (id: string, patch: Partial<ClosetSection>) => void;
  addSection: () => void;
  removeSection: (id: string) => void;
}

let nextSecId = 100;

export const useClosetStore = create<State>((set) => ({
  spec: DEFAULT_CLOSET,
  setSpec: (next) => set({ spec: next }),
  patch: (patch) => set((s) => ({ spec: { ...s.spec, ...patch } })),
  patchMaterial: (patch) =>
    set((s) => ({
      spec: { ...s.spec, material: { ...s.spec.material, ...patch } },
    })),
  patchCeiling: (patch) =>
    set((s) => ({
      spec: { ...s.spec, ceiling: { ...s.spec.ceiling, ...patch } },
    })),
  updateSection: (id, patch) =>
    set((s) => ({
      spec: {
        ...s.spec,
        sections: s.spec.sections.map((sec) =>
          sec.id === id ? { ...sec, ...patch } : sec,
        ),
      },
    })),
  addSection: () =>
    set((s) => {
      const id = `s${nextSecId++}`;
      return {
        spec: {
          ...s.spec,
          sections: [
            ...s.spec.sections,
            {
              id,
              width: 60,
              shelfCount: 4,
              hangingRod: false,
              drawerStack: false,
            },
          ],
        },
      };
    }),
  removeSection: (id) =>
    set((s) => ({
      spec: {
        ...s.spec,
        sections: s.spec.sections.filter((sec) => sec.id !== id),
      },
    })),
}));
